import { render, staticRenderFns } from "./ChooseProduct.vue?vue&type=template&id=50fd3c8e&"
import script from "./ChooseProduct.vue?vue&type=script&lang=js&"
export * from "./ChooseProduct.vue?vue&type=script&lang=js&"
import style0 from "./ChooseProduct.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports